export default __webpack_public_path__ + "poster_center_slider.png";